const justifyItems = {
    name: "justify-items",
    path: "/justify-items",
    title: "justify-items",
    description: "Utilities for controlling how grid items are aligned along their inline axis.",
    value: {
        "justify-items": {
          "justify-items-start": "start",
          "justify-items-end": "end",
          "justify-items-end-safe": "safe end",
          "justify-items-center": "center",
          "justify-items-center-safe": "safe center",
          "justify-items-stretch": "stretch",
          "justify-items-normal": "normal",
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="grid justify-items-start ...">
  <div>01</div>
  <div>02</div>
  <div>03</div>
  <div>04</div>
  <div>05</div>
  <div>06</div>
</div>

<div class="grid grid-flow-col justify-items-end ...">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>


<div class="grid grid-flow-col justify-items-center ...">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>


<div class="grid justify-items-stretch ...">
  <div>01</div>
  <div>02</div>
  <div>03</div>
  <div>04</div>
  <div>05</div>
  <div>06</div>
</div>
                `
            },
        },
        
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">justify-items-start</code>
                  utility to justify grid items against the start of their inline axis:
            </p>
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">justify-items-end, justify-items-end-safe</code>
                  utilities to justify grid items against the end of their inline axis:
            </p>
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">justify-items-center, justify-items-center-safe</code>
                  utilities to justify grid items against the end of their inline axis:
            </p>
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">justify-items-stretch</code>
                  utility to stretch items along their inline axis:
            </p>

            <div class="grid md:grid-columns-2 gap-10">
                <div>
                    <small class="text-center block mb-4">justify-items-start</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="flex justify-items-start gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="flex size-14 shrink-0 items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                        </div>
                    </div>
                </div>

                <div>
                    <small class="text-center block mb-4">justify-items-end</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-1 justify-items-end gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="flex size-14 shrink-0 items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                        </div>
                    </div>
                </div>

                <div>
                    <small class="text-center block mb-4">justify-items-center</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-1 justify-items-center gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="flex size-14 shrink-0 items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                        </div>
                    </div>
                </div>

                <div>
                    <small class="text-center block mb-4">justify-items-stretch</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-1 justify-items-stretch gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="flex h-14 shrink-0 items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                        </div>
                    </div>
                </div>
            </div>

            
            `
        },
    ]
};



export default justifyItems;

<div className="sr-only md:grid-columns-2 justify-items-start justify-items-end justify-items-end-safe justify-items-center justify-items-center-safe justify-items-stretch justify-items-normal">



</div>